import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cardNumber: string;
    cvc: string;
    expiration: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the card number input field */
            cardNumber: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "BillingStripeCardElements.cardNumber?c=u15ezmnr7hob", defaultMessage: "Card number" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the CVC (Card Verification Code) input field */
            cvc: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "BillingStripeCardElements.cvc?c=2an437bbrhhsd", defaultMessage: "CVC" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the card expiration date input field */
            expiration: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "BillingStripeCardElements.expiration?c=2ab3n5on2pwgf", defaultMessage: "Expiration" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
